(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meta-collection-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('meta-collection-spotlight')) return;
    class MetaCollectionSpotlight extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.items = Array.from(this.querySelectorAll('[data-spotlight-item]'));
        this.scenes = Array.from(this.querySelectorAll('[data-spotlight-scene]'));
        this.cta = this.querySelector('[data-spotlight-cta]');
        this.ctaCategory = this.querySelector('[data-spotlight-cta-category]');
        if (!this.items.length || !this.cta || this.scenes.length !== this.items.length) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.activeIndex = -1;
        this.frame = 0;
        this.nearViewport = false;
        this.update = this.update.bind(this);
        const schedule = () => {
          if (!this.nearViewport || this.frame) return;
          this.frame = window.requestAnimationFrame(this.update);
        };
        window.addEventListener('scroll', schedule, { passive: true, signal });
        window.addEventListener('resize', schedule, { passive: true, signal });
        this.motion.addEventListener('change', schedule, { signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            this.nearViewport = entries.some((entry) => entry.isIntersecting);
            schedule();
          }, { rootMargin: '120px 0px' });
          this.observer.observe(this);
        } else {
          this.nearViewport = true;
          schedule();
        }
        this.items.forEach((item, index) => {
          item.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowDown') next = (index + 1) % this.items.length;
            if (event.key === 'ArrowUp') next = (index - 1 + this.items.length) % this.items.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.items.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.items[next].focus();
          }, { signal });
        });
        this.ownerDocument.addEventListener('shopify:block:select', (event) => {
          const index = this.items.findIndex((item) => item.dataset.blockId === event.detail?.blockId);
          if (index < 0) return;
          this.scenes[index].scrollIntoView({ behavior: 'instant', block: 'start' });
          this.activate(index);
          schedule();
        }, { signal });
        this.activate(0);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        window.cancelAnimationFrame(this.frame);
      }
      update() {
        this.frame = 0;
        if (!this.isConnected || !this.nearViewport) return;
        const viewHeight = window.innerHeight;
        const center = viewHeight * .52;
        let nearest = 0;
        let distance = Infinity;
        this.scenes.forEach((scene, index) => {
          const rect = scene.getBoundingClientRect();
          const offset = center - (rect.top + rect.height / 2);
          if (Math.abs(offset) < distance) {
            distance = Math.abs(offset);
            nearest = index;
          }
          if (rect.bottom >= 0 && rect.top <= viewHeight) {
            const drift = this.motion.matches ? 0 : Math.max(-24, Math.min(24, offset * .035));
            scene.style.setProperty('--spotlight-drift', drift.toFixed(1) + 'px');
          }
        });
        this.activate(nearest);
      }
      activate(index) {
        if (index === this.activeIndex || index < 0 || index >= this.items.length) return;
        this.activeIndex = index;
        this.items.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle('is-active', active);
          if (active) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
          this.scenes[itemIndex].classList.toggle('is-active', active);
        });
        const item = this.items[index];
        this.cta.href = item.href;
        this.cta.removeAttribute('aria-label');
        if (this.ctaCategory) this.ctaCategory.textContent = item.dataset.category || '';
      }
    }
    customElements.define('meta-collection-spotlight', MetaCollectionSpotlight);
  })();

  } catch(e) { console.error(e); }
})();
})();
